import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {apiQuery} from "../../utils/appConfig";
import {Response} from "../../types/response/Response";
import {EmployeeDTO} from "../../types/employee/EmployeeDTO";
import {EmployeeSelfDTO} from "../../types/employee/EmployeeSelfDTO";

export const employeeApi = createApi({
    reducerPath: 'employee',
    baseQuery: apiQuery,
    tagTypes: ["self", "employee", "employee_list"],
    endpoints: builder => ({
        getSelfEmployee: builder.query<Response<EmployeeSelfDTO>, void>({
            query: () => '/api/v1/employees/self',
            providesTags: ['self']
        }),
        getEmployees: builder.query<Response<EmployeeDTO[]>, void>({
            query: () => 'api/v1/employees',
            providesTags: ['employee_list']
        })
    })
})

export const {useGetSelfEmployeeQuery, useGetEmployeesQuery} = employeeApi